import CryptoJS from 'crypto-js';

export function base64ToString(message: string) {
	const encodedWord = CryptoJS.enc.Base64.parse(message); // encodedWord via Base64.parse()
	const decoded = CryptoJS.enc.Utf8.stringify(encodedWord); // decode encodedWord via Utf8.stringify() '75322541'
	return decoded;
}
